import { render, staticRenderFns } from "./XBonExportFragment.vue?vue&type=template&id=597515b2&scoped=true&"
import script from "./XBonExportFragment.vue?vue&type=script&lang=js&"
export * from "./XBonExportFragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597515b2",
  null
  
)

export default component.exports